export const id_pkcs_1 = "1.2.840.113549.1.1";
export const id_rsaEncryption = `${id_pkcs_1}.1`;
export const id_RSAES_OAEP = `${id_pkcs_1}.7`;
export const id_pSpecified = `${id_pkcs_1}.9`;
export const id_RSASSA_PSS = `${id_pkcs_1}.10`;
export const id_md2WithRSAEncryption = `${id_pkcs_1}.2`;
export const id_md5WithRSAEncryption = `${id_pkcs_1}.4`;
export const id_sha1WithRSAEncryption = `${id_pkcs_1}.5`;
export const id_sha224WithRSAEncryption = `${id_pkcs_1}.14`;
export const id_ssha224WithRSAEncryption = id_sha224WithRSAEncryption;
export const id_sha256WithRSAEncryption = `${id_pkcs_1}.11`;
export const id_sha384WithRSAEncryption = `${id_pkcs_1}.12`;
export const id_sha512WithRSAEncryption = `${id_pkcs_1}.13`;
export const id_sha512_224WithRSAEncryption = `${id_pkcs_1}.15`;
export const id_sha512_256WithRSAEncryption = `${id_pkcs_1}.16`;
export const id_sha1 = "1.3.14.3.2.26";
export const id_sha224 = "2.16.840.1.101.3.4.2.4";
export const id_sha256 = "2.16.840.1.101.3.4.2.1";
export const id_sha384 = "2.16.840.1.101.3.4.2.2";
export const id_sha512 = "2.16.840.1.101.3.4.2.3";
export const id_sha512_224 = "2.16.840.1.101.3.4.2.5";
export const id_sha512_256 = "2.16.840.1.101.3.4.2.6";
export const id_md2 = "1.2.840.113549.2.2";
export const id_md5 = "1.2.840.113549.2.5";
export const id_mgf1 = `${id_pkcs_1}.8`;
